// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#donationForm {
    background-color: var(--light);
    filter: var(--shadow);
    padding: 32px 10vmin;
    max-width: 650px;
    border-radius: 8px;
    margin: 0 auto;
}

#donationForm h2 {
    text-align: center;
}

#donationForm label {
    margin-top: 8px;
    display: block;
    color: var(--dark);
    font-weight: 600;
}

#donationForm .textInput {
    display: block;
    margin-top: 4px;
    margin-bottom: 16px;
    height: 2.25em;
    border-radius: 6px;
    width: 100%;
    border: 1px solid var(--dark);
    filter: var(--shadow-muted);
    padding: 8px;
    font-size: 1.05em;
    font-family: 'Kumbh Sans', sans-serif;
}

#donationForm textarea {
    height: auto !important;
    max-width: none !important;
    width: 100% !important;
}

#donationForm .checkboxLabel {
    margin: 0;
    display: inline;
    font-size: 0.9em;
    font-weight: 500;
}

#donationForm input[type=checkbox] {
    margin: 0;
    margin-right: 8px;
    accent-color: var(--dark);
}

#donationForm .currencyInput {
    font-size: 1.2em;
    display: block;
    width: fit-content;
    margin-bottom: -15px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

#donationForm .currencyInput input {
    display: inline-block;
    text-align: right;
    width: 60px;
    margin: 0;
}

#donationForm button {
    margin: 16px auto;
}

#donationForm .submitDonation {
    margin-top: 36px;
}`, "",{"version":3,"sources":["webpack://./src/css/DonationForm.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,6BAA6B;IAC7B,2BAA2B;IAC3B,YAAY;IACZ,iBAAiB;IACjB,qCAAqC;AACzC;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["#donationForm {\n    background-color: var(--light);\n    filter: var(--shadow);\n    padding: 32px 10vmin;\n    max-width: 650px;\n    border-radius: 8px;\n    margin: 0 auto;\n}\n\n#donationForm h2 {\n    text-align: center;\n}\n\n#donationForm label {\n    margin-top: 8px;\n    display: block;\n    color: var(--dark);\n    font-weight: 600;\n}\n\n#donationForm .textInput {\n    display: block;\n    margin-top: 4px;\n    margin-bottom: 16px;\n    height: 2.25em;\n    border-radius: 6px;\n    width: 100%;\n    border: 1px solid var(--dark);\n    filter: var(--shadow-muted);\n    padding: 8px;\n    font-size: 1.05em;\n    font-family: 'Kumbh Sans', sans-serif;\n}\n\n#donationForm textarea {\n    height: auto !important;\n    max-width: none !important;\n    width: 100% !important;\n}\n\n#donationForm .checkboxLabel {\n    margin: 0;\n    display: inline;\n    font-size: 0.9em;\n    font-weight: 500;\n}\n\n#donationForm input[type=checkbox] {\n    margin: 0;\n    margin-right: 8px;\n    accent-color: var(--dark);\n}\n\n#donationForm .currencyInput {\n    font-size: 1.2em;\n    display: block;\n    width: fit-content;\n    margin-bottom: -15px;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n#donationForm .currencyInput input {\n    display: inline-block;\n    text-align: right;\n    width: 60px;\n    margin: 0;\n}\n\n#donationForm button {\n    margin: 16px auto;\n}\n\n#donationForm .submitDonation {\n    margin-top: 36px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
